var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padded"},[_vm._m(0),_vm._v(" "),_c('events-calendar',{attrs:{"category":"rentals"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Rentals by Month")])
}]

export { render, staticRenderFns }